<template>
  <div>
    <van-nav-bar
      title="个人中心"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="information">
      <img src="https://img.yzcdn.cn/vant/cat.jpeg" @click="personalInfolist()"/>
      <div class="information1">
        <span>汪娅鹏</span>
        <span>已实名认证</span>
        <span>车辆认证</span>
      </div>
      <div class="information2">
        <span>总单数：100单</span>
        <span>总里程：100公里</span>
        <span>总时长：100小时</span>
      </div>
    </div>
    <div class="van-tite">
      <van-row>
        <van-col @click="allorders()" span="6">
          <img src="../../assets/Group4@2x1.png" />
          <span class="list-box">我的订单</span>
        </van-col>
        <van-col span="6" @click="vehicleinsurance()">
          <img src="../../assets/Group4@2x.png" />
          <span class="list-box">我的车辆</span>
        </van-col>
        <van-col span="6" @click="problemfeedback()">
          <img src="../../assets/Rectangle@2x1.png" />
          <span class="list-box">问题反馈</span>
        </van-col>
        <van-col span="6">
          <img src="../../assets/Rectangle@2x.png" />
          <span class="list-box">车机绑定</span>
        </van-col>
      </van-row>
    </div>
    <ih-panel
      v-for="(item, key) in panelList"
      @click.native="toRoute(item.route)"
      :url="item.url"
      :text="item.text"
      :key="key"
    >
    </ih-panel>
	
  </div>
</template>
<script>
// import NavBar from "@/components/navBar";
import ihPanel from "@/components/ihPanel";
import { Col, Row, NavBar } from "vant";
// Vue.use(Col);
// Vue.use(Row);
export default {
  name: "home",
  data() {
    return {
      panelList: [
        {
          url: require("@/assets/Rectangle5.png"),
          text: "账户与安全",
          route: "accountSafe"
        },
        {
          url: require("@/assets/Rectangle5.png"),
          text: "问题反馈",
          route: "assessSuccess"
        },
		{
		  url: require("@/assets/pt.png"),
		  text: "我的评价",
		  route: "homeManager"
      // assess 评价页面  暂时改为车队长
		},
        {
          url: require("@/assets/Rectangle6.png"),
          text: "平台使用帮助",
          route: "aboutUs"
        },
        {
          url: require("@/assets/pt.png"),
          text: "法律条款与平台规则",
          route: "aboutUs"
        },
        {
          url: require("@/assets/Rectangle7.png"),
          text: "关于我们",
          route: "aboutUs"
        },
        {
          url: require("@/assets/Rectangle2.png"),
          text: "退出登录",
		  route:"aboutUs"
        }
      ]
    };
  },
  components: {
    ihPanel,
    "van-col": Col,
    "van-row": Row,
	"van-nav-bar":NavBar,
	
  },
  methods: {
	onClickLeft() {
	      window.open("app:/#/finish")
	   },
    toRoute(name) {
      this.$router.push({ name });
    },
	personalInfolist(){
		 this.$router.push({ name:"personalInfolist" });
	},
    vehicleinsurance() {
		// this.$router.push({
		//         path:'./accountSafe/cardManage',
		//         query:{
		//           id:id
		//         }
		//       })
		
      this.$router.push({name: "cardManage"});
    },
    problemfeedback() {
		this.$router.push({name:'problemfeedbacklist' })
      // this.$router.push({ name: "problemfeedbacklist" });
    },
    allorders() {
      this.$router.push({ name: "allorders" }
	  );
    },	
	// showPopup(){
	// 	  window.open("app:/#/exit")
	// 	},
  }
};
</script>
<style lang="less" scoped>
.p1{
	width: 30px;
	height: 20px;
	background: yellow;
	position: absolute;
	top: 0;
	z-index: 999;
	opacity: 0;
}
		
.van-tite {
  margin-top: 10px;
  margin-bottom: 10px;
}
.van-tite van-row {
  width: 100%;
  height: 100%;
}
.list-box {
  display: block;
  text-align: center;
  line-height: 25px;
  font-size: 14px;
}
.van-col img {
  width: 0.9rem;
  height: 0.9rem;
  display: block;
  margin: auto;
}
.information {
  width: 100%;
  overflow: hidden;
}
.information img {
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  float: left;
  margin-left: 0.3rem;
  margin-top: 0.3rem;
}
.information1,
.information2 {
  float: left;
  margin-top: 0.3rem;
  margin-left: 0.3rem;
  font-size: 12px;
}
.information1 span:nth-child(1) {
  font-size: 14px;
}
.information1 span:nth-child(2) {
  font-size: 11px;
  color: #ff9500;
  margin-left: 0.3rem;
  border: 1px solid #ff9500;
  border-radius: 3px;
}
.information1 span:nth-child(3) {
  font-size: 11px;
  color: #ff9500;
  margin-left: 0.3rem;
  border: 1px solid #ff9500;
  border-radius: 3px;
}
.information2 span:nth-child(1) {
  margin-left: 0rem;
}
.information2 span {
  margin-left: 0.2rem;
}
.inform-box {
  display: block;
}
</style>
